<template>

    <div class="news-item" :class="'layout-' + layout" v-if="newsItem">

        <div class="photo" v-if="newsItem.photo.path">
            <img :src="newsItem.photo.path" :alt="newsItem.photo.alt">
        </div>
        <div class="video" v-if="newsItem.video.url">
            <div class="video-wrapper">
                <iframe :src="newsItem.video.url"></iframe>
            </div>
        </div>

        <div class="details">
            <div class="tags" v-if="newsItem.tags" :class="{ 'has-ribbon': newsItem.ribbonColor.length, 'has-photo': newsItem.photo.path, 'has-video': newsItem.video.url }">
                <div class="ribbon" v-if="newsItem.ribbonColor" :style="'background-color: ' + newsItem.ribbonColor + ';'"></div>
                <a href="#" :key="tag.id" v-for="(tag, index) in newsItem.tags">
                    <span>{{ tag.displayName }} <span class="pipe" v-if="index !== newsItem.tags.length - 1"> | </span></span>
                </a>
            </div>

            <div class="date">{{ newsItem.date | moment("D - MMM") }}</div>

            <h3 class="title">{{ newsItem.title }}</h3>

            <div class="description">{{ newsItem.description }}</div>

            <PrimaryCTA v-if="newsItem.cta" :linkText="newsItem.cta.linkText" :linkURL="newsItem.cta.linkURL"></PrimaryCTA>
        </div>
    </div>
	
</template>

<script>

	import PrimaryCTA from '../Global/PrimaryCTA.vue';
	
	export default {
		name: 'NewsItem',
		
		props: ['newsItem', 'layout'],
		
		components: {
			PrimaryCTA
		}
	}
	
</script>